import { 
    onSwitcherStart, 
    onSwitcherEnd, 
    onSwitcherSuccess, 
    onSwitcherError,
    emitSwitcherStart, 
    emitSwitcherEnd, 
    emitSwitcherSuccess, 
    emitSwitcherError
} from "../event_bus";

export function initRemoveButton(options) {
    options.onSwitcherStart && onSwitcherStart(options.onSwitcherStart);
    options.onSwitcherEnd && onSwitcherEnd(options.onSwitcherEnd);
    options.onSwitcherSuccess && onSwitcherSuccess(options.onSwitcherSuccess);
    options.onSwitcherError && onSwitcherError(options.onSwitcherError);

    $(document).on("click", ".wishlist-remove-button:not(.guest-mode)", function () {
        const $this = $(this);
        const pid = $this.data("pid");
        const removeUrl = $this.data("remove-url");
        const eventBaseParams = { type: "remove", pid, $element: $this };

        emitSwitcherStart(eventBaseParams);

        $.ajax({
            url: removeUrl,
            method: "POST",
            success: function (data) {
                document.dispatchEvent(new CustomEvent("dataLayer.removeFromWishlist", {
                    detail: {
                        "productImpression": data?.oldImpression?.productImpression,
                        "customerId": data?.oldImpression?.customerId
                    }
                }));
                emitSwitcherSuccess(eventBaseParams);
            },
            error: function (err) {
                emitSwitcherError({ ...eventBaseParams, err });
            },
            complete: function (status) {
                emitSwitcherEnd({ ...eventBaseParams, status });
            }
        });
    });
}
